import { useCallback } from 'react';

import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { PaginatedTrackingRowList, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface QueryKeyType {
  pageParam?: UrlParams;
}

interface IUseCommittedClubTracking {
  month?: string;
  programStatus?: string;
  limit?: string;
}

function useCommittedClubTracking({
  month,
  programStatus,
  limit = '25',
}: IUseCommittedClubTracking): UseInfiniteQueryResult<AxiosResponse<PaginatedTrackingRowList>> {
  const fetchTracking = useCallback(
    ({
      pageParam = { limit, offset: '0' },
    }: QueryKeyType): Promise<AxiosResponse<PaginatedTrackingRowList>> => {
      const params = pageParam;

      if (month) params.month = month;
      if (programStatus) params.program_status = programStatus;

      return client.get(`check-in-program/tracking/?${encodeUrlParams(params)}`);
    },
    [limit, month, programStatus],
  );

  return useInfiniteQuery(['committedClubTracking', month, programStatus], fetchTracking, {
    getNextPageParam: page => (page.data.next ? urlParamsFromUrl(page.data.next) : undefined),
  });
}

export default useCommittedClubTracking;
